import { render, staticRenderFns } from "./ArchitecturalControlTwoCard.vue?vue&type=template&id=e052920e&scoped=true&"
import script from "./ArchitecturalControlTwoCard.vue?vue&type=script&lang=js&"
export * from "./ArchitecturalControlTwoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e052920e",
  null
  
)

export default component.exports